module.exports = __webpack_public_path__ + "static/media/autoDoor6.a69a5a90.png";